import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function PublicSeoDetailLinks({ title, links = [], hideLabel = false }) {
  if (!links.length) return null;

  return (
    <section id="featured-public-pages" className="scroll-mt-24 space-y-4">
      <div>
        {!hideLabel && <p className="text-sm font-semibold uppercase tracking-wider text-primary">Programmatic SEO</p>}
        <h2 className="mt-2 font-heading text-3xl font-bold">{title}</h2>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {links.map(link => (
          <Link key={link.href} to={link.href}>
            <Card className="h-full transition-colors hover:border-primary/50">
              <CardContent className="flex h-full items-start justify-between gap-4 p-5">
                <div>
                  <h3 className="font-semibold text-foreground">{link.label}</h3>
                  <p className="mt-2 text-sm leading-6 text-muted-foreground">{link.description}</p>
                </div>
                <ArrowUpRight className="h-4 w-4 shrink-0 text-primary" />
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  );
}